



































































import Vue from "vue";
import SkillsAnimation from "@/components/modules/skills/SkillsAnimation.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  FETCH_SUPPLY_SKILLS,
  SUPPLY_SKILL_DATA
} from "@/store/modules/institute/constants";
import SkillHeader from "@/components/modules/skills/SkillHeader.vue";
import { get_skill_related_data } from "@/utils/skills_data";
import CustomSelect from "@/components/shared/CustomSelect.vue";

export default Vue.extend({
  name: "SkillMap",
  components: { SkillsAnimation, SkillHeader, CustomSelect },
  data() {
    return {
      selected_city: { text: "Dubai", img: "/cities/Dubai.png" } as any,
      pagination: 1,
      limit: 60,
      page: 1,
      loading: false
    };
  },
  computed: {
    ...mapGetters("institute", {
      get_supply_data: SUPPLY_SKILL_DATA
    }),
    cityBackgroundStyle(): any {
      return {
        backgroundImage: `url(${this.selected_city.img})`
      };
    },
    selected_data(): any {
      return this.get_supply_data.results.slice(
        (this.page - 1) * this.limit,
        this.page * this.limit
      );
    }
  },
  async mounted() {
    this.selected_city = this.get_skill_related_data("UAE_States").find(
      (item: any) => item?.text === this.get_supply_data.state
    );
    await this.initiateData();
  },
  methods: {
    get_skill_related_data,
    ...mapActions("institute", {
      fetch_supply_skills: FETCH_SUPPLY_SKILLS
    }),
    async initiateData() {
      this.page = 1;
      this.loading = true;
      const payload = {
        page: this.get_supply_data.page,
        limit: this.get_supply_data.limit,
        state: this.selected_city.text,
        course_title: this.get_supply_data.course_title,
        institute: this.get_supply_data.institute,
        category: this.get_supply_data.category
      };
      await this.fetch_supply_skills(payload);
      this.loading = false;
    },
    extractData(page: number) {
      this.page = page;
    },
    change_city(item: any) {
      this.selected_city = item;
      this.initiateData();
    }
  }
});
